jQuery_T4NT(document).ready(function($) {
  
    document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
      ele.addEventListener("input", function () {
      if (this.value < 0) {
          this.value = 0;
      }
    });
  });

  $(document).on("variant:changed", function (evt) {
    // console.log(evt.currentVariant.title);
    if (evt.currentVariant.title.includes('Customized')) {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.removeAttribute("disabled");
        });
    } else {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.setAttribute("disabled", "disabled");
        });
    };
  });

  var allPagesLoaded = false; // Flag to track if all pages have been loaded

  $(window).scroll(function() {
      var paginationWrapper = $('.sr4-pagination-wrapper');
      var loadPreviewButton = $('.loadpreview');
      
      // Check if URL contains ?page=1
      if (window.location.href.indexOf('?page=1') !== -1) {
          return; // Stop further execution if ?page=1 is in the URL
      }

      if (!allPagesLoaded && paginationWrapper.length && loadPreviewButton.length) {
          if (isInViewport(paginationWrapper)) {
              loadPreviewButton.click();
          }
      }
  });

 // Function to indicate that all pages have been loaded
  function setAllPagesLoaded() {
      allPagesLoaded = true;
  }

  // Call setAllPagesLoaded() function when all pages are loaded
  // Replace the selector '#page' with the appropriate selector for your pagination elements
  $(document).on('allPagesLoadedEvent', setAllPagesLoaded);

  // Function to check if an element is in the viewport
  function isInViewport(elem) {
      var bounding = elem[0].getBoundingClientRect();
      return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
  }

for (let i = 0; i <= 9; i++) {
$(`.JAVA-${i}`).click(function() {
  // Hide all elements with class starting with "PYTHON-"
  for (let j = 0; j <= 9; j++) {
    if (j !== i) {
      $(`.PYTHON-${j}`).css("display", "none");
    }
  }
  // Remove "is--opend" class from all elements with class starting with "JAVA-"
  for (let k = 0; k <= 9; k++) {
    if (k !== i) {
      $(`.JAVA-${k}`).removeClass("is--opend");
    }
  }
});
}

   /**
   *  Variant selection changed
   *  data-variant-toggle="{{ variant.id }}"
   */
   $( document ).on( "variant:changed", function( evt ) {
     console.log( evt.currentVariant );
     // $('[data-variant-toggle]').hide(0);
     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
   });


function enforceMaxQuantityOnClick(selector, targetInput, maxQuantity) {
  $(selector).on('click', function() {
    // console.log("ahmer")
      setTimeout(function() {
        enforceMaxQuantity('.aaa', 5);
          $(targetInput).trigger('change');
      }, 1000); // Delay of 1 second (1000 milliseconds)
  });
}

function enforceMaxQuantity(selector, maxQuantity) {
  $(selector).on('change', function() {
      var inputValue = parseInt($(this).val(), 10);
      if (inputValue > maxQuantity) {
          alert('The quantity cannot be greater than ' + maxQuantity + '.');
          $(this).val(maxQuantity);  // Reset the value to maxQuantity if exceeded
      }
  });
}

// Monitor clicks on the button with the class 'a.sr4-btn__cart'



// Usage
enforceMaxQuantity('.aaa', 5);
enforceMaxQuantityOnClick('.ad', '.aaa', 5);




$(document).ready(function() {
  // Check if the last child has the class 'sr4-current-cat'
  if ($('.sr4-top-list-collections .flickitysr4-slider .sr4-cat-item:last-child').hasClass('sr4-current-cat')) {
      // If it has the class, trigger a click on the next button
      $('button.flickitysr4-button.flickitysr4-prev-next-button.next').trigger('click');
  }
});


// $(document).ready(function(){
//   $('.readmore').on('click', function() {
//     var discpInner = $('.discpInner');

//     if (discpInner.hasClass('expanded')) {
//       // If expanded, collapse it
//       discpInner.removeClass('expanded').css('height', '50px');
//       $(this).text('Read More');
//     } else {
//       // If collapsed, expand it
//       var fullHeight = discpInner[0].scrollHeight;
//       discpInner.addClass('expanded').css('height', fullHeight + 'px');
//       $(this).text('Read Less');
//     }
//   });
// });
  
});

// Then, attach the new click event handler
$('#sr4-mini_cart a.sr4-btn__cart,#sr4-mini_cart button.sr4-btn__checkout').on('click', function(event) {
  // Get the current value of the quantity input field
  var quantity = $('div#sr4-mini_cart .sr4-mini_cart__actions .sr4-quantity-input').val();

  // Check if the value is greater than 5
  if (quantity > 5) {
      // Show an alert
      alert('The quantity cannot be greater than 5.');

      // Prevent the default action (if needed)
      event.preventDefault();
  }
});
